import React from "react";
import PropTypes from "prop-types";
const HashIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 16}
    height={height || size || 16}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-53-27h245V90H-53z" />
      <path
        fill={color || "var(--color-easil-gray-x-dark)"}
        d="M14 2a1 1 0 011 1v2h2a1 1 0 010 2h-2v6h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2H7v2a1 1 0 01-2 0v-2H3a1 1 0 010-2h2V7H3a1 1 0 110-2h2V3a1 1 0 112 0v2h6V3a1 1 0 011-1zm-1 5H7v6h6V7z"
      />
    </g>
  </svg>
);
HashIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default HashIcon;
